import styled from "@emotion/styled"
import { radius4Xl, spacingStaticXs, typescaleXs } from "@porsche-design-system/components-react/emotion"
import { SkeletonText } from "./SkeletonText"

interface SkeletonTagProps {
	$width?: string
	className?: string
	compact?: boolean
}

export const SkeletonTag = ({ $width, className, compact }: SkeletonTagProps) => (
	<StyledSkeletonText className={className} $compact={compact} $width={$width} />
)

const StyledSkeletonText = styled(SkeletonText)<{ $compact?: boolean; $width?: string }>`
	padding: ${({ $compact }) => ($compact ? "1px" : spacingStaticXs)};
	font-size: ${typescaleXs};
	border-radius: ${radius4Xl};
	width: ${({ $width }) => $width ?? "100px"};
`
